import specialIcon from "../../../assets/images/specials-info-icon.svg";
import { getSpecialsList } from "../../../utils/util";
import Tooltip from "../../Tooltip/tooltip";
import styles from "../floorplans.module.scss";

export default function FloorplanSpecialComponent({
  typeListing,
  specials,
  fpId,
}) {
  const specialsList = getSpecialsList(specials);

  if (typeListing) {
    if (!specialsList?.includes(fpId)) {
      return null;
    } else {
      return (
        <div className={styles.FloorplanSpecialComponent}>
          <Tooltip text={specials?.floorplan[specialsList[0]]?.description}>
            <span className={styles.specialsInfo}>
            Special Offer <img src={specialIcon} alt="Special" />
            </span>
          </Tooltip>
        </div>
      );
    }
  } else {
    if (!specialsList?.some((id) => fpId === id)) {
      return null;
    } else {
      return (
        <div className={styles.FloorplanSpecialComponent}>
          <Tooltip text={specials?.floorplan[fpId]?.description}>
            <span className={styles.specialsInfo}>
            Special Offer <img src={specialIcon} alt="Special" />
            </span>
          </Tooltip>
        </div>
      );
    }
  }
}
